<h1 class="page-header"><i class="fa fa-eye" aria-hidden="true"></i> SECURITY</h1>
<div class="container-fluid">

  <div class="panel panel-default">
    <div class="panel-heading">
      <h2 class="panel-title"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ACTIVE ALERTS</h2>
    </div>
    <div class="panel-body panel-table">
      <div class="table-responsive security-table">
        <table id="dashboardTableActive" class="table tablesorter tablesorter-default table-hover" data-toggle='table'
          data-id-field='userid'>
          <thead>
            <tr>
              <th class="table-checkbox"></th>
              <th class='header sorting' data-field='id' data-sortable='true' (click)='onSort("ACTIVE", "ID")'
                [ngClass]="{'sort-ascending': (this.activeAlertSortDirection=='ASC' && this.activeAlertSortValue == 'ID'), 'sort-descending': (this.activeAlertSortDirection=='DESC' && this.activeAlertSortValue == 'ID')}">
                ID</th>
              <th class='header sorting' data-field='id' data-sortable='true' (click)='onSort("ACTIVE", "DATE")'
                [ngClass]="{'sort-ascending': (this.activeAlertSortDirection=='ASC' && this.activeAlertSortValue == 'DATE'), 'sort-descending': (this.activeAlertSortDirection=='DESC' && this.activeAlertSortValue == 'DATE')}">
                DATE
              </th>
              <th class='header sorting' data-field='id' data-sortable='true' (click)='onSort("ACTIVE", "ALERT TYPE")'
                [ngClass]="{'sort-ascending': (this.activeAlertSortDirection=='ASC' && this.activeAlertSortValue == 'ALERT TYPE'), 'sort-descending': (this.activeAlertSortDirection=='DESC' && this.activeAlertSortValue == 'ALERT TYPE')}">
                ALERT TYPE</th>
              <th class='header sorting' data-field='id' data-sortable='true' (click)='onSort("ACTIVE", "LOCATION")'
                [ngClass]="{'sort-ascending': (this.activeAlertSortDirection=='ASC' && this.activeAlertSortValue == 'LOCATION'), 'sort-descending': (this.activeAlertSortDirection=='DESC' && this.activeAlertSortValue == 'LOCATION')}">
                LOCATION</th>
              <th class='header sorting' data-field='id' data-sortable='true' (click)='onSort("ACTIVE", "ZONE")'
                [ngClass]="{'sort-ascending': (this.activeAlertSortDirection=='ASC' && this.activeAlertSortValue == 'ZONE'), 'sort-descending': (this.activeAlertSortDirection=='DESC' && this.activeAlertSortValue == 'ZONE')}">
                ZONE
              </th>
              <th class='header sorting unsortable' data-field='id' data-sortable='true'>
                ALERT FROM</th>
              <th class='header sorting unsortable' data-field='id' data-sortable='true'>
                RESPONDER</th>
            </tr>
          </thead>
          <tbody *ngFor="let dialogInstance of dialogInstancesOpen">
            <tr>
              <td>
                <div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
                    (click)="dialogCheckboxSelected(dialogInstance.id, this.checked)"><label for="checkbox"></label>
                </div>
              </td>
              <td (click)="showAlertDialog(dialogInstance)">{{ dialogInstance.id }}</td>
              <td (click)="showAlertDialog(dialogInstance)">{{ dialogInstance.creationDate | date:"MMM d, y h:mm a" }}
              </td>
              <td (click)="showAlertDialog(dialogInstance)">{{ dialogInstance.dialog.name }}</td>
              <td (click)="showAlertDialog(dialogInstance)">{{ (dialogInstance.locationInstance) ?
                dialogInstance.locationInstance.name : "" }}</td>
              <td (click)="showAlertDialog(dialogInstance)">{{ (dialogInstance.zoneInstance) ?
                dialogInstance.zoneInstance.name : "" }}</td>
              <td (click)="showAlertDialog(dialogInstance)">{{ (dialogInstance.user) ? (dialogInstance.user.firstName +
                " " + dialogInstance.user.lastName) : "" }}</td>
              <td (click)="showAlertDialog(dialogInstance)">{{ (dialogInstance.owner) ? (dialogInstance.owner.firstName
                + " " + dialogInstance.owner.lastName) : "" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="panel-footer" id="activeAlertsTableNavigation">
      <h6>PAGE {{ openStartPage + 1 }} OF {{ numberOpenPages }}</h6>
      <div class="btn-group">
        <a class="btn btn-default" (click)="moveStartOpenPage()"><i class="fa fa-angle-double-left"
            aria-hidden="true"></i></a>
        <a class="btn btn-default" (click)="moveBackOpenPage()"><i class="fa fa-angle-left" aria-hidden="true"></i></a>
        <ng-container *ngFor="let pageNumber of numberOpenPagesAsArray; let i = index">
          <ng-container
            *ngIf="pageNumber >= (openStartPage - openStartPage % 5) && i < 5 + (openStartPage - openStartPage % 5)">
            <ng-container *ngIf="pageNumber == openStartPage">
              <a class="btn btn-primary" (click)="getOpenPagesOfPageSize(pageNumber)">{{ (pageNumber + 1) }}</a>
            </ng-container>
            <ng-container *ngIf="pageNumber != openStartPage">
              <a class="btn btn-default" (click)="getOpenPagesOfPageSize(pageNumber)">{{ (pageNumber + 1) }}</a>
            </ng-container>
          </ng-container>
        </ng-container>
        <a class="btn btn-default" (click)="moveForwardOpenPage()"><i class="fa fa-angle-right"
            aria-hidden="true"></i></a>
        <a class="btn btn-default" (click)="moveEndOpenPage()"> <i class="fa fa-angle-double-right"
            aria-hidden="true"></i></a>
      </div>
    </div>
  </div>

  <div class="panel panel-default">
    <div class="panel-heading">
      <h2 class="panel-title"><i class="fa fa-check" aria-hidden="true"></i> CLOSED ALERTS</h2>
    </div>
    <div class="panel-body panel-table">
      <div class="table-responsive security-table">
        <table id="dashboardTableClosed" class="table tablesorter tablesorter-default table-hover" data-toggle='table'
          data-id-field='userid'>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th class='header sorting' data-field='id' data-sortable='true' (click)='onSort("CLOSED", "ID")'
                [ngClass]="{'sort-ascending': (this.closedAlertSortDirection=='ASC' && this.closedAlertSortValue == 'ID'), 'sort-descending': (this.closedAlertSortDirection=='DESC' && this.closedAlertSortValue == 'ID')}">
                ID</th>
              <th class='header sorting' data-field='id' data-sortable='true' (click)='onSort("CLOSED", "DATE")'
                [ngClass]="{'sort-ascending': (this.closedAlertSortDirection=='ASC' && this.closedAlertSortValue == 'DATE'), 'sort-descending': (this.closedAlertSortDirection=='DESC' && this.closedAlertSortValue == 'DATE')}">
                DATE</th>
              <th class='header sorting' data-field='id' data-sortable='true' (click)='onSort("CLOSED", "ALERT TYPE")'
                [ngClass]="{'sort-ascending': (this.closedAlertSortDirection=='ASC' && this.closedAlertSortValue == 'ALERT TYPE'), 'sort-descending': (this.closedAlertSortDirection=='DESC' && this.closedAlertSortValue == 'ALERT TYPE')}">
                ALERT TYPE</th>
              <th class='header sorting' data-field='id' data-sortable='true' (click)='onSort("CLOSED", "LOCATION")'
                [ngClass]="{'sort-ascending': (this.closedAlertSortDirection=='ASC' && this.closedAlertSortValue == 'LOCATION'), 'sort-descending': (this.closedAlertSortDirection=='DESC' && this.closedAlertSortValue == 'LOCATION')}">
                LOCATION</th>
              <th class='header sorting' data-field='id' data-sortable='true' (click)='onSort("CLOSED", "ZONE")'
                [ngClass]="{'sort-ascending': (this.closedAlertSortDirection=='ASC' && this.closedAlertSortValue == 'ZONE'), 'sort-descending': (this.closedAlertSortDirection=='DESC' && this.closedAlertSortValue == 'ZONE')}">
                ZONE</th>
              <th class='header sorting unsortable' data-field='id' data-sortable='true'>
                ALERT FROM</th>
              <th class='header sorting unsortable' data-field='id' data-sortable='true'>
                RESPONDER</th>
            </tr>
          </thead>
          <tbody *ngFor="let dialogInstance of dialogInstancesClosed">
            <tr>
              <td>
                <div class="checkbox checkbox-inline"><input type='checkbox' class="styled"
                    (click)="dialogCheckboxSelected(dialogInstance.id)"><label for="checkbox"></label></div>
              </td>
              <td (click)="showAlertDialog(dialogInstance)">{{ dialogInstance.id }}</td>
              <td (click)="showAlertDialog(dialogInstance)">{{ dialogInstance.creationDate | date:"MMM d, y h:mm a" }}
              </td>
              <td (click)="showAlertDialog(dialogInstance)">{{ dialogInstance.dialog.name }}</td>
              <td (click)="showAlertDialog(dialogInstance)">{{ (dialogInstance.locationInstance) ?
                dialogInstance.locationInstance.name : "" }}</td>
              <td (click)="showAlertDialog(dialogInstance)">{{ (dialogInstance.zoneInstance) ?
                dialogInstance.zoneInstance.name : "" }}</td>
              <td (click)="showAlertDialog(dialogInstance)">{{ (dialogInstance.user) ? (dialogInstance.user.firstName +
                " " + dialogInstance.user.lastName) : "" }}</td>
              <td (click)="showAlertDialog(dialogInstance)">{{ (dialogInstance.owner) ? (dialogInstance.owner.firstName
                + " " + dialogInstance.owner.lastName) : "" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="panel-footer" id="closedAlertsTableNavigation">
      <h6>PAGE {{ closedStartPage + 1 }} OF {{ numberClosedPages }}</h6>
      <div class="btn-group">
        <a class="btn btn-default" (click)="moveStartClosePage()"><i class="fa fa-angle-double-left"
            aria-hidden="true"></i></a>
        <a class="btn btn-default" (click)="moveBackClosePage()"><i class="fa fa-angle-left" aria-hidden="true"></i></a>
        <ng-container *ngFor="let pageNumber of numberClosedPagesAsArray; let i = index">
          <ng-container
            *ngIf="pageNumber >= (closedStartPage - closedStartPage % 5) && i < 5 + (closedStartPage - closedStartPage % 5)">
            <ng-container *ngIf="pageNumber == closedStartPage">
              <a class="btn btn-primary" (click)="getClosedPagesOfPageSize(pageNumber)">{{ (pageNumber + 1) }}</a>
            </ng-container>
            <ng-container *ngIf="pageNumber != closedStartPage">
              <a class="btn btn-default" (click)="getClosedPagesOfPageSize(pageNumber)">{{ (pageNumber + 1) }}</a>
            </ng-container>
          </ng-container>
        </ng-container>
        <a class="btn btn-default" (click)="moveForwardClosePage()"><i class="fa fa-angle-right"
            aria-hidden="true"></i></a>
        <a class="btn btn-default" (click)="moveEndClosePage()"> <i class="fa fa-angle-double-right"
            aria-hidden="true"></i></a>
      </div>
    </div>
  </div>
</div>